module.exports = __webpack_public_path__ + "img/news-1-2.69ddd6d6.png";